import { render, staticRenderFns } from "./SalesOrderExtendDialog.vue?vue&type=template&id=bc2326fc"
import script from "./SalesOrderExtendDialog.vue?vue&type=script&lang=js"
export * from "./SalesOrderExtendDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports